export default __webpack_public_path__ + "static/media/dani-ice-age.3bb5ffe1.jpeg";